var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding",attrs:{"data-cy":"onboarding-pricing"}},[_c('TopBar',{attrs:{"closeButton":""},on:{"close":_vm.onClose}}),(_vm.usesStiggIntegration)?_c('PricingStigg',{attrs:{"theme":_vm.theme}}):_c('Pricing',{attrs:{"theme":_vm.theme,"onboardingFlow":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }